<template>
  <b-overlay :show="payments === null" rounded="sm">
    <div v-if="payments !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <h1 class="mb-2">لیست پرداخت ها</h1>
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                v-model="perPage"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="جستجو..."
                />
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="payments"
          responsive
          :fields="myTableColumns"
          primary-key="id"
          show-empty
          bordered
          striped
          empty-text="موردی موجود نیست!"
        >
          <template #cell(userInfo)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="45"
                  :src="`https://api.faradidar.com/${data.item.userInfo.selfieFileData}`"
                  :variant="`success`"
                  :to="{
                    name: 'apps-users-edit',
                    params: { id: data.item.userInfo.userId },
                  }"
                />
              </template>
              <b-link
                :to="{
                  name: 'apps-users-edit',
                  params: { id: data.item.userInfo.userId },
                }"
                class="font-weight-bold d-block text-nowrap"
              >
                {{
                  data.item.userInfo.name + " " + data.item.userInfo.familyName
                }}
              </b-link>
              <small class="text-muted">@{{ data.item.userId }}</small>
            </b-media>
          </template>

          <!-- Column: Status -->
          <template #cell(status)="data">
            <b-badge
              v-if="data.item.status === 0"
              pill
              class="text-capitalize"
              :variant="`success`"
            >
              پرداخت موفق
            </b-badge>
            <b-badge
              v-if="data.item.status === 2"
              pill
              class="text-capitalize"
              :variant="`success`"
            >
              پرداخت موفق
            </b-badge>
            <b-badge
              v-else-if="data.item.status === 1"
              pill
              class="text-capitalize"
              :variant="`danger`"
            >
              در انتظار پرداخت
            </b-badge>
          </template>

          <!-- Column: amount -->
          <template #cell(amount)="data">
            <span> {{ makePrettyPrice(data.item.amount) }} تومان </span>
          </template>

          <!-- Column: state -->
          <template #cell(userInfo.state)="data">
            <b-badge
              v-if="data.item.userInfo.state === 2"
              pill
              class="text-capitalize"
              :variant="`success`"
            >
              وارد شده
            </b-badge>
            <b-badge
              v-else-if="data.item.userInfo.state === 1"
              pill
              class="text-capitalize"
              :variant="`warning`"
            >
              فالو نکرده
            </b-badge>
            <b-badge
              v-else-if="data.item.userInfo.state === 3"
              pill
              class="text-capitalize"
              :variant="`danger`"
            >
              آیدی اشتباه
            </b-badge>
          </template>

          <!-- Column: chat -->
          <template #cell(chat)="data">
            <b-link
              :to="{
                name: 'apps-chats-id',
                params: { id: data.item.userInfo.userId },
              }"
            >
              <feather-icon icon="MessageCircleIcon" size="20" />
            </b-link>
          </template>

          <!--          &lt;!&ndash; Column: Actions &ndash;&gt;-->
          <!--          <template #cell(actions)="data">-->
          <!--            <b-dropdown-->
          <!--                variant="link"-->
          <!--                no-caret-->
          <!--                :right="$store.state.appConfig.isRTL"-->
          <!--            >-->

          <!--              <template #button-content>-->
          <!--                <feather-icon-->
          <!--                    icon="MoreVerticalIcon"-->
          <!--                    size="16"-->
          <!--                    class="align-middle text-body"-->
          <!--                />-->
          <!--              </template>-->
          <!--              -->
          <!--              <b-dropdown-item :to="{ name: 'apps-users-factors', params: { id: data.item.userId } }">-->
          <!--                <feather-icon icon="ListIcon" />-->
          <!--                <span class="align-middle ml-50">نمایش فاکتورها</span>-->
          <!--              </b-dropdown-item>-->

          <!--            </b-dropdown>-->
          <!--          </template>-->
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalCounts"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import vSelect from "vue-select";
import UsersGetAllRequest from "@/libs/Api/Users/UsersGetAllRequest";
import PaymentGetAllRequest from "@/libs/Api/Payment/PaymentGetAllRequest";
import Helper from "@/libs/Helper";

export default {
  title: "لیست پرداخت ها - پنل ادمین فرادیدار",
  name: "PaymentsList",
  data() {
    return {
      payments: null,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        { key: "userInfo", label: "اطلاعات کاربر" },
        { key: "userInfo.mobile", label: "موبایل" },
        { key: "paymentId", label: "شناسه پرداخت" },
        { key: "status", label: "وضعیت پرداخت" },
        { key: "amount", label: "مقدار پرداخت" },
        // { key: 'actions',label:'عملیات'},
      ],
      searchQuery: "",
    };
  },
  async created() {
    await this.getPayments(this.perPage, this.currentPage, this.searchQuery);
  },
  methods: {
    refreshData() {
      this.getPayments(this.perPage, this.currentPage, this.searchQuery);
    },
    async getPayments(count, pageNumber, search) {
      let _this = this;
      let data = {
        pageNumber: pageNumber,
        count: count,
        search: search,
      };

      let paymentGetAllRequest = new PaymentGetAllRequest(_this);
      paymentGetAllRequest.setParams(data);
      await paymentGetAllRequest.fetch(
        function (content) {
          _this.payments = content.payments;
          _this.totalCounts = content.paymentsCount;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR");
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0);
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getPayments(nv, this.currentPage, this.searchQuery);
    },
    currentPage: function (nv, ov) {
      this.getPayments(this.perPage, nv, this.searchQuery);
    },
    searchQuery: function (nv, ov) {
      this.getPayments(this.perPage, this.currentPage, nv);
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,

    vSelect,
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
